import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconChevronUp: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.33333"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4 10L8 6L12 10"
    />
  </svg>
);

export {
  IconChevronUp,
};
